import React from 'react';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import {
  FDBox,
  FDStack, FDTitleText,
} from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import PropTypes from 'prop-types';

const Layout = ({ direction }) => {
  const { resource } = useMetaLayoutContext();

  return (
    <FDStack direction={direction} spacing={2} wrap={direction === 'row'} alignItems={'flex-start'} justifyContent="flex-start">
      <FDBox width={'100%'}>
        <FDTitleText
          value={'Previous Planner Information'}
        />
      </FDBox>
      <MetaControlField
        attr={'plannerName'}
        resource={resource}
      />
      <MetaControlField
        attr={'lastDay'}
        resource={resource}
      />
      <MetaControlField
        attr={'meetingCutoffDate'}
        resource={resource}
      />
    </FDStack>
  );
};

Layout.defaultProps = {
  direction: 'column',
};

Layout.propTypes = {
  direction: PropTypes.oneOf(['row, column']),
};

export default Layout;
